import React, { useEffect, useRef } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { Search as SearchIcon } from "lucide-react";

export function MapView({ spots, onSelect, onSearchArea }) {
  const ref = useRef(null);
  const map = useRef(null);
  const layer = useRef(null);

  useEffect(() => {
    if (!ref.current || map.current) return;
    map.current = L.map(ref.current, { scrollWheelZoom: true, attributionControl: true }).setView([37.8, -96], 4);
    L.tileLayer("https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Dark_Gray_Base/MapServer/tile/{z}/{y}/{x}", {
      attribution: 'Tiles &copy; Esri', maxZoom: 16,
    }).addTo(map.current);
    layer.current = L.layerGroup().addTo(map.current);
    setTimeout(() => map.current && map.current.invalidateSize(), 200);
  }, []);

  useEffect(() => {
    if (!map.current || !layer.current) return;
    layer.current.clearLayers();
    const pts = spots.filter((s) => s.lat != null && s.lng != null);
    pts.forEach((s) => {
      const icon = L.divIcon({ className: "", html: `<div class="opn-pin">${s.speed_mbps}</div>`, iconSize: [46, 46], iconAnchor: [23, 23] });
      const m = L.marker([s.lat, s.lng], { icon }).addTo(layer.current);
      m.on("click", () => onSelect(s));
      m.bindTooltip(`${s.name} · $${s.monthly_price}/mo`, { direction: "top", offset: [0, -16] });
    });
    if (pts.length) {
      const b = L.latLngBounds(pts.map((s) => [s.lat, s.lng]));
      map.current.fitBounds(b.pad(0.35), { maxZoom: 12 });
    }
    setTimeout(() => map.current && map.current.invalidateSize(), 150);
  }, [spots, onSelect]);

  const searchHere = () => {
    if (!map.current || !onSearchArea) return;
    const b = map.current.getBounds();
    onSearchArea({ min_lat: b.getSouth(), max_lat: b.getNorth(), min_lng: b.getWest(), max_lng: b.getEast() });
  };

  return (
    <div className="relative">
      {onSearchArea && (
        <button onClick={searchHere} data-testid="search-this-area"
          className="absolute top-3 left-1/2 -translate-x-1/2 z-[1000] flex items-center gap-2 px-4 h-10 rounded-full bg-foreground text-background text-sm font-medium shadow-lg hover:opacity-90 transition-opacity">
          <SearchIcon size={14} /> Search this area
        </button>
      )}
      <div ref={ref} data-testid="hotspot-map" className="h-[460px] w-full rounded-2xl overflow-hidden border border-border" style={{ zIndex: 0 }} />
    </div>
  );
}
